import React from 'react';
import { Modal } from '../../components/ui';
import { fmtDate, fmtTime } from '../../utils/helpers';
import { useFunctionShare } from './useFunctionShare';

// Phone "share these functions": tick, then send — the preview sits underneath.
export default function ShareFunctionsMobile(props) {
  const vm = useFunctionShare(props);
  const {
    invitable, picked, toggle, allOn, toggleAll, chosen,
    from, setFrom, message, setMessage, withMap, setWithMap,
    preview, copy, whatsapp, share, canShare, close,
  } = vm;

  return (
    <Modal
      fullScreen title="Share functions" onClose={close}
      footer={<>
        <button className="btn light" onClick={close}>Close</button>
        <button className="btn primary" style={{ flex: 1, padding: 12 }} data-save="primary"
          disabled={!chosen.length} onClick={whatsapp}>Send on WhatsApp</button>
      </>}
    >
      <div className="step-label">
        Which functions
        <button type="button" className="linklike" style={{ marginLeft: 8 }} onClick={toggleAll}>{allOn ? 'none' : 'all'}</button>
      </div>
      <div className="share-fn-list">
        {invitable.length === 0 && <div className="muted">Every function of this event is over.</div>}
        {invitable.map(f => (
          <label key={f.FunctionId} className={'share-fn-row' + (picked.includes(String(f.FunctionId)) ? ' on' : '')}>
            <input type="checkbox" checked={picked.includes(String(f.FunctionId))} onChange={() => toggle(f.FunctionId)} />
            <span>
              <strong>{f.FunctionName}</strong>
              <span className="muted">{' '}· {fmtDate(f.FunctionDate)}{f.StartTime ? ` · ${fmtTime(f.StartTime)}` : ''}</span>
            </span>
          </label>
        ))}
      </div>

      <label className="field">Message on top
        <textarea rows={2} value={message} onChange={e => setMessage(e.target.value)} />
      </label>
      <label className="field">From
        <input value={from} onChange={e => setFrom(e.target.value)} placeholder="Ailani Family" />
      </label>
      <label className="share-fn-map">
        <input type="checkbox" checked={withMap} onChange={e => setWithMap(e.target.checked)} />
        Add a map link for each venue
      </label>

      <div className="step-label">What they receive</div>
      <div className="share-fn-preview">
            {preview.map(line => (
              <div key={line.key} className={line.signature ? 'share-fn-sign' : undefined}>
                {line.parts.map((p, i) => (p.bold ? <strong key={i}>{p.text}</strong> : <span key={i}>{p.text}</span>))}
                {line.parts.length === 0 ? ' ' : null}
              </div>
            ))}
          </div>

      <div style={{ display: 'grid', gap: 8, marginTop: 10 }}>
        <button className="btn light" style={{ padding: 12 }} onClick={copy}>⧉ Copy message</button>
        {canShare && <button className="btn light" style={{ padding: 12 }} onClick={share}>↗ Share another way</button>}
      </div>
    </Modal>
  );
}
